import { ReactElement } from "react"

import CreateEVDCDeviceForm from "../../../../components/devices/lct/evdc/createEVDCDeviceForm"
import PublishEVDCDeviceProvider from "../../../../components/devices/lct/evdc/providers/publishEVDCDeviceProvider"

/** Component to publish a new EVDC device */
const PublishEVDCDevice = (): ReactElement => (
    <PublishEVDCDeviceProvider>
        <CreateEVDCDeviceForm />
    </PublishEVDCDeviceProvider>
)

export default PublishEVDCDevice
